var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      staticClass: "md-danger md-just-icon md-round",
      attrs: { title: "Delete shipment" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleDeleteShipment(_vm.shipmentId)
        },
      },
    },
    [_c("md-icon", [_vm._v("delete")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }